module.exports = __webpack_public_path__ + "static/brokenskiplink2-035fb6e84bbf10d79da774794459b3f9.png";